import React from 'react'
import CartPage from '~/app/components-nds/domestic/cart/cart-page'
import getServerSideViewerInfo from '~/app/utils/getServerSideViewerInfo'
import NDSResetProvider from '~/app/components-nds/common/nds-reset-provider'

const Index = () => {
  return (
    <NDSResetProvider>
      <CartPage />
    </NDSResetProvider>
  )
}

export async function getServerSideProps(ctx) {
  const { viewer } = await getServerSideViewerInfo(ctx)

  return {
    props: {
      viewer,
    },
  }
}

export default Index
